import { render, staticRenderFns } from "./func-dialog.vue?vue&type=template&id=be3d8850&scoped=true&"
import script from "./func-dialog.vue?vue&type=script&lang=js&"
export * from "./func-dialog.vue?vue&type=script&lang=js&"
import style0 from "./func-dialog.vue?vue&type=style&index=0&id=be3d8850&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be3d8850",
  null
  
)

export default component.exports